import { render, staticRenderFns } from "./SectorsTagsEditor.vue?vue&type=template&id=2eca9ea6&"
import script from "./SectorsTagsEditor.vue?vue&type=script&lang=js&"
export * from "./SectorsTagsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports